import { render, staticRenderFns } from "./DeleteWebsiteDialog.vue?vue&type=template&id=540019ac&"
import script from "./DeleteWebsiteDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteWebsiteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports